import ConfirmationCannotDelete from './ConfirmationCannotDelete';

export default ConfirmationCannotDelete;
